import RichTextEditorExpandModal from './RichTextEditorExpandModal.component';

export default RichTextEditorExpandModal;